// extracted by mini-css-extract-plugin
export default {"center":"Button_center__sC-a5","button":"Button_button__csJVT"};